import * as PIXI from "pixi.js";
import { BASE_PATH, LOGO_PATH } from "../types/Config";
import fetchFromDato from "../api/fetchFromDato";
import { GameCardResponse } from "../types/Interface";


export default class TextureManager {
  private static basePath = BASE_PATH;
  private static logoPath: string = `${this.basePath}${LOGO_PATH}`;
  private static assetList: string[];
  private static textures: Record<string, PIXI.Texture>;
  private static logo: Record<string, PIXI.Texture>;
  private static infoSliderAssetURLs: string[] = [];

  constructor() { }

  static getLogo = () => new PIXI.Texture(this.logo);

  static async load(assetsList: string[], cb: (p: number) => void): Promise<void> {
    this.assetList = [...assetsList.map(asset => `${asset.includes("http") ? "" : this.basePath}${asset}`)];
    this.textures = await PIXI.Assets.load(this.assetList, (p: number) => cb(Math.floor(p * 100)));
  }
  static async loadLogo(): Promise<void> {
    this.logo = await PIXI.Assets.load(this.logoPath);
  }
  static getTexture(_path: string | String): PIXI.Texture {
    const path = `${_path.includes("http") ? "" : this.basePath}${_path}`;
    let Texture = this.textures[path];
    if (!Texture) {
      console.log("Texture is not found", path);
      Texture = PIXI.Texture.WHITE;
    }
    return new PIXI.Texture(Texture);
  }
  static async getAssetsUrls(assetsSlug: string): Promise<any> {
    if (assetsSlug === undefined && assetsSlug == "") {
      this.infoSliderAssetURLs = []
    } else {
      const data: GameCardResponse = await fetchFromDato(assetsSlug);
      this.infoSliderAssetURLs = (data && data.gameCard) ? data.gameCard.cards.map(card => card.image.url) : [];
    }
    return this.infoSliderAssetURLs;
  }
  static getInfoSliderAssetURLs = () => this.infoSliderAssetURLs;
}